import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Navbar from './components/NavBar/Navbar';
import Footer from './components/Footer/Footer';
import PackagePage from './pages/PackagePage';  
import './App.css';
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <Router>
      <Navbar/>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/packages/:id" element={<PackagePage />} />
      </Routes>
      <Toaster position="top-right" reverseOrder={false} />
      <Footer/>
    </Router>
  );
}

export default App;
